import { Typography } from '@navi/web-ui/lib/primitives';
import Tooltip from '@navi/web-ui/lib/primitives/Tooltip/Tooltip';
import { ICellRendererParams } from 'ag-grid-community';
import CallHistory from 'src/components/CallHistory/CallHistory';
import { formatDate } from 'src/utils/commonUtils';
import AlternateNumberCell from '../components/MoreDetails/AlternateNumberCell';
import { Address } from '../interfaces/MoreDetails.type';

export const LOAN_DRAWER_HEADER_TEXT = 'Loan breakup';

export const NO_ALTERNATE_NUMBER_TEXT = 'No alternate numbers';
export const NO_ALTERNATE_ADDRESS_TEXT = 'No alternate addresses';

export const LoanBreakupFields = {
  LOAN_ACCOUNT_NUMBER: 'Loan account number',
  LOAN_AMOUNT: 'Loan amount',
  DISBURSAL_DATE: 'Disbursal date',
  LOAN_TENURE: 'Loan tenure',
  ANNUAL_INTEREST: 'Annual interest',
  EMI_AMOUNT: 'EMI amount',
  EMI_END_DATE: 'EMI end date'
};

export const LoanAccountFields = {
  PRODUCT: 'Product',
  LAN: 'LAN',
  LOAN_AMOUNT: 'Loan Amount'
};

export const VirtualAccountFields = {
  ACC_NO: 'Acc no.',
  IFSC_CODE: 'IFSC code'
};

export const ALTERNATE_NO_COLUMN_DEFS = [
  {
    field: 'number',
    headerName: 'Number',
    cellRenderer: AlternateNumberCell
  },
  {
    field: 'source',
    headerName: 'Source',
    valueGetter: (params: ICellRendererParams) => TELEPHONE_SOURCE_TYPES[params.data.source]
  },
  {
    field: 'createdAt',
    headerName: 'Added on',
    cellRenderer: (params: ICellRendererParams) => formatDate(params.value, { year: 'numeric' })
  },
  {
    field: 'contactStatus',
    headerName: 'Contact status',
    cellRendererSelector: (params: ICellRendererParams) => {
      return {
        component: CallHistory,
        params: {
          list: params.data.callHistory || [],
          showTooltip: true
        }
      };
    }
  }
];

export const ALTERNATE_ADDRESS_COLUMN_DEFS = [
  {
    field: 'address',
    headerName: 'Address',
    cellRenderer: (params: ICellRendererParams) => {
      const { lineOne, lineTwo, city, state, pinCode } = params.data as Address;
      const addressString = [lineOne, lineTwo, city, state, pinCode]
        .filter(line => !!line)
        .join(', ');
      return (
        <Tooltip
          text={addressString}
          position="bottom"
          style={{
            width: '100%'
          }}
        >
          <Typography variant={'p4'} className={'address-name-typography'}>
            {addressString}
          </Typography>
        </Tooltip>
      );
    },
    cellClass: 'address-name-cell',
    width: 400
  },
  {
    field: 'source',
    headerName: 'Source',
    //TODO: backend should send the exact value of address source.
    valueGetter: (params: ICellRendererParams) =>
      ADDRESS_SOURCE_TYPES[params.data.source] || params.data.source
  },
  {
    field: 'ingestionDate',
    headerName: 'Added on',
    cellRenderer: (params: ICellRendererParams) => formatDate(params.value, { year: 'numeric' })
  },
  {
    field: 'signal',
    headerName: 'Contact status',
    valueGetter: (params: ICellRendererParams) =>
      params.data?.signal?.visited === 'true' ? ContactStatus.VISITED : ContactStatus.NOT_VISITED
  }
];

const ADDRESS_SOURCE_TYPES = {
  KARZA: 'Karza',
  PRIMARY: 'Primary',
  LONGHORN: 'Longhorn'
} as { [key: string]: string };

const TELEPHONE_SOURCE_TYPES = {
  PRIMARY: 'Primary',
  LONGHORN: 'Longhorn'
} as { [key: string]: string };

export const PRODUCT_TYPE = { PERSONAL_LOAN: 'Personal loan', HOUSING_LOAN: 'Housing loan' } as {
  [key: string]: string;
};

const ContactStatus = {
  VISITED: 'Visited',
  NOT_VISITED: 'Not visited'
};

export enum AddNewNumberKind {
  INITIAL_STATE,
  CLOSE,
  BEFORE_API_CALL,
  API_ERROR,
  API_CALL_SUCCESS,
  SET_NUMBER
}
export enum AddNewEmailKind {
  INITIAL_STATE,
  CLOSE,
  BEFORE_API_CALL,
  API_ERROR,
  API_CALL_SUCCESS,
  SET_EMAIL
}

export const TagColor = 'blue';

export const emailTooltipTriggerNumber = 24;

export const tooltipCopy = 'Click to copy';

export const tooltipArrowColor = 'var(--tooltip-background-color)';

export const gmailComposeLink = 'https://mail.google.com/mail/?view=cm&fs=1&to=';

export const gmeetCallLink = 'https://meet.google.com/calling/';

export const PHONE_NUMBER = 'phoneNumber';

export const SOURCE = 'source';

export const OTHER_SOURCE = 'otherSource';

export const CUSTOMER_CONFIDENCE = 'customerConfidence';

export enum PhoneNumberValidations {
  VALID_PHONE_NUMBER = 'Enter a valid 10 digit mobile number',
  PHONE_NUMBER_EXISTS = 'Phone number already exists',
  NUMBER_MARKED_INVALID = 'Number marked invalid previously',
  ERROR = 'Error in validating number'
}

export enum OtherSourceValidations {
  MIN_SOURCE_LENGTH = 'Enter at least 3 characters',
  SAME_CHARACTERS = 'All characters cannot be same',
  ONLY_SPECIAL_CHARACTERS = 'Only special characters are not allowed'
}
